(function($) {
    window.dataLayer = window.dataLayer || []

    /*
    Other push locations:
    - purchase, contentPurchase, user_data (after purchase) - includes/shortcodes/thank-you-summary.php
     */

    function datalayer_push(source, event = null, data = null, items = null){

        if (source === 'ga'){ // Google Analytics
            if (!Array.isArray(items)){
                items = [items]
            }

            let push_data = {
                event: event,
                ecommerce: {
                    items: items
                }
            }

            if (data){
                $.each(data, function(index, item) {
                    push_data["ecommerce"][index] = item
                })
            }

            window.dataLayer.push(push_data)
        }
        else if (source === 'ads'){ // Ad platforms
            let push_data = {
                event: event
            }
            if (data){
                $.each(data, function(index, item) {
                    push_data[index] = item
                })
            }

            window.dataLayer.push(push_data)
        }
        else {  // Other platforms
            window.dataLayer.push(data)
        }
    }

    function get_checkout_items(){
        let checkout_list_items = []

        $("div.checkout_review__items div.checkout_review__item[data-layer-product]").each(function () {

            let checkout_item = $(this).attr('data-layer-product')
            if (checkout_item){
                checkout_item = $.parseJSON(checkout_item)

                let variation = $(this).find('p.checkout_review__item_variation') // TODO po doplneni velikosti do souhrnu objednavky
                if (variation){
                    variation = variation.text().replace('Velikost: ', '')
                    checkout_item["item_variant"] = variation
                }
                let quantity = $(this).find('span.checkout_review__item-qty')
                if (quantity.length){
                    quantity = quantity.text().match(/\d+/)[0]
                    checkout_item["quantity"] = quantity
                }
                else {
                    // Quantity not found, probably a gift
                    checkout_item["quantity"] = 1
                }

                checkout_list_items.push(checkout_item)
            }
        })

        return checkout_list_items
    }

    /*
        PRODUCTS
     */

    // Push viewed product list to data layer
    let product_list_items = []
    $("div.products_item[data-layer-product]").each(function (){
        product_list_items.push($.parseJSON($(this).attr('data-layer-product')))
    })

    if (product_list_items.length > 0){
        datalayer_push('ga', 'view_item_list', null, product_list_items)
    }

    // Push products loaded via AJAX to data layer
    $(document).on("ghostpress-ajax-products-loaded", function (event, data){
        datalayer_push('ga', 'view_item_list', null, data)
    })

    // Push clicked product to data layer
    $("div.products_archive div.products_item").click(function (){

        let clicked_product = $.parseJSON($(this).attr('data-layer-product'))
        if (clicked_product){
            datalayer_push('ga', 'select_item', null, clicked_product)
        }
    })

    // Push single viewed product to data layer
    let single_product = $('body.single-product div.product[data-layer-product]')
    if (single_product.length){

        let viewed_product = $.parseJSON(single_product.attr('data-layer-product'))
        if (viewed_product){
            // Google Analytics
            datalayer_push('ga', 'view_item', null, viewed_product)

            // Ads
            let viewContent = {
                "content_ids": [viewed_product["item_id"]],
                "value": parseFloat(viewed_product["price"])
            }
            datalayer_push('ads', 'viewContent', viewContent)
        }
    }

    // Push viewed category to data layer
    let viewed_category = $('body.archive.tax-product_cat')
    if (viewed_category.length){
        let category_name = viewed_category.find('h1.products_archive__header-headline')
        let category_breadcrumb = viewed_category.find('div.breadcrumbs')

        // Ads
        let content_ids = []
        for (let i = 0; i < 6; i++){
            if (product_list_items[i]){
                content_ids.push(product_list_items[i]["item_id"])
            }
            else {
                break
            }
        }

        let viewCategory = {}
        if (category_name){
            viewCategory["content_name"] = category_name.text()
        }
        if (category_breadcrumb){
            let breadcrumb = "";
            category_breadcrumb.find("a[href]:not(:first-of-type)").each(function (){
                breadcrumb += `${$(this).text()} > `
            })

            breadcrumb += category_breadcrumb.find("span.last").text()
            viewCategory["content_category"] = breadcrumb
        }
        if (content_ids){
            viewCategory["content_ids"] = content_ids
        }
        datalayer_push('ads', 'viewCategory', viewCategory, null)

        // Zbozi.cz
        let zbozi_category = $("div.products_items[data-product-zbozi-id]").attr('data-product-zbozi-id')
        if (zbozi_category){
            datalayer_push('zbozi', null, {"zbozi_kategorie": zbozi_category})
        }
    }

    /*
        CART
     */

    // View cart
    $(document).on('open_sidebar', (event, id_sidebar) => {
        if (id_sidebar !== "cart"){
            return;
        }

        let cart_list_items = []
        $("div.sidebar__cart div.checkout_review__item-cart[data-layer-product]").each(function (){
            let cart_item = $(this).attr('data-layer-product')
            if (cart_item){
                cart_item = $.parseJSON(cart_item)

                let variation = $(this).find('div.checkout_review__item-about-left span.checkout_review__item-text')
                if (variation){
                    variation = variation.text().replace('Velikost: ', '')
                    if (variation.length > 0){
                        cart_item["item_variant"] = variation
                    }
                }
                let quantity = $(this).find('span.checkout_review__item-quantity-text')
                if (quantity.length){
                    quantity = quantity.text().match(/\d+/)[0]
                    cart_item["quantity"] = parseInt(quantity)
                }
                else {
                    // Quantity not found, probably a gift
                    cart_item["quantity"] = 1
                }

                cart_list_items.push(cart_item)
            }
        })

        datalayer_push('ga', 'view_cart', null, cart_list_items)
    })

    // Add to and remove from cart
    $(document).on("ghostpress-cart-datalayer-push", function (event, data){

        let cart_data = null

        if (data.action && data.action === "remove"){
            delete data["action"]
            datalayer_push('ga', 'remove_from_cart', null, data)
        }
        else {
            delete data["action"]
            if (data.cart){
                cart_data = data.cart
                delete data["cart"]
            }

            // Google Analytics
            datalayer_push('ga', 'add_to_cart', cart_data, data)

            // Ads
            let addToCart = {
                "content_ids": [data["item_id"]],
                "value": parseFloat(data["price"])
            }
            datalayer_push('ads', 'addToCart', addToCart)
        }
    })

    /*
        CHECKOUT
     */

    // Begin checkout
    if ($("form#checkout__form-first-step").length > 0) {
        let checkout_list_items = get_checkout_items()

        if (checkout_list_items.length > 0) {
            datalayer_push('ga', 'begin_checkout', null, checkout_list_items)

            let item_ids = []
            $.each(checkout_list_items, function (index, item) {
                item_ids.push(item["item_id"])
            })

            let initiateCheckout = {
                "content_ids": item_ids
            }

            let order_total = $('div.checkout_review__row-data--tax span.checkout_review__row-price[data-cart-total]').attr('data-cart-total')
            if (order_total) {
                initiateCheckout["value"] = parseFloat(order_total)
            }

            datalayer_push('ads', 'initiateCheckout', initiateCheckout)
        }
    }

    // Add shipping + payment - after reaching second step
    if ($("form#checkout__form-second-step").length > 0){
        // - Shipping info
        let shipping = $('div.checkout_review__row-shipping .checkout_review__row-title')
        let shipping_data = {}
        if (shipping){
            shipping_data = {'shipping_tier': shipping.text()}
        }

        let items = get_checkout_items()
        $.each(items, function (index){
            delete items[index]["item_list_name"]
            delete items[index]["item_list_id"]
        })
        datalayer_push('ga', 'add_shipping_info', shipping_data, items)

        // - Payment info
        let payment = $('div.checkout_review__row-payment .checkout_review__row-title')
        let payment_data = {}
        if (payment){
            payment_data = {'payment_type': payment.text()}
        }

        datalayer_push('ga', 'add_payment_info', payment_data, items)
    }

    /*
        SEARCH
     */

    // Push search results
    if ($("body.archive.search").length > 0){
        // Ads
        let contentSearch = {}

        if (product_list_items.length > 0){
            let content_ids = []

            for (let i = 0; i < 6; i++){
                if (product_list_items[i]){
                    content_ids.push(product_list_items[i]["item_id"])
                }
                else {
                    break
                }
            }

            if (content_ids){
                contentSearch["content_ids"] = content_ids
            }
        }

        const url_params = new URLSearchParams(window.location.search)
        const search_string = url_params.get('s')
        if (search_string.length > 0){
            contentSearch["search_string"] = search_string
        }

        datalayer_push('ads', 'contentSearch', contentSearch, null)
    }

})(jQuery);
